import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ReplayIcon from '@mui/icons-material/Replay';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Logo from '../../toolbars/Logo';

import livros from '../../assets/livros.png';

export default function Error(props) {
  const { mensagem } = props;
  return (
    <React.Fragment>
      <AppBar
        position="static"
        sx={{
          backgroundImage: 'radial-gradient(#24142e, #3f3045)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Toolbar>
          <Logo version={props.version} />
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          marginTop: { xs: '-140px', sm: 0 },
        }}>
        <Box
          sx={{
            width: 300,
            height: 380,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'top',
            textAlign: 'center',
            backgroundImage: `url(${livros})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
          }}>
            {mensagem}
            <Button
              color="branca"
              variant="contained"
              sx={{ mt: 1 }}
              onClick={()=>{
                window.location.pathname = '/';
              }}
              startIcon={<ReplayIcon />}>
              Voltar à página inicial
            </Button>
        </Typography>
        </Box>
      </Box>
    </React.Fragment>
  );
}
